<template>
  <a-card>
    <div class="twoCode">
      <div class="codeBox">
        <a-image v-if="erweimaCode" style="width: 100%;height: 100%;object-fit: cover;" :src="getImg(erweimaCode)" />
        <img style="width: 100%;height: 100%;object-fit: cover;" v-else src="@/assets/img/defaultImg.png" alt="" />
      </div>
      <p>微信扫码加群</p>
    </div>
    <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
      <a-form-item label="兑现年份" name="year">
        <YearPicker style="width: 100%" v-model:value="searchForm.year" :format="dateFormat.DATE_YEAR"
          :showTime="false" />
      </a-form-item>
      <!-- <a-form-item label="高企编号" name="highNumber">
        <a-input v-model:value="searchForm.highNumber" placeholder="请输入" />
      </a-form-item> -->
      <a-form-item>
        <a-button type="primary" @click="onSearch">查询</a-button>
        <a-button @click="onReset">重置</a-button>
      </a-form-item>
    </a-form>
    <div class="table-toolbar">
      <a-button type="primary" @click="onAdd">
        <template #icon>
          <plus-outlined />
        </template>
        申请入口
      </a-button>
      <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)">
        <a-button danger>批量删除</a-button>
      </a-popconfirm>
    </div>
    <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
      <template #message>
        已选择 {{ selectedRowKeys.length }} 项
        <a @click="onClearSelected" class="ml-20 float-right">清空</a>
      </template>
    </a-alert>
    <p style="margin-bottom: 10px;color: red">如果状态显示审核通过，请点击申报资料下载，打印下载的申报资料一式三份，
盖章报回管委会319室，联系电话：0353-2292730</p>
    <a-table :columns="columns"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: onGetCheckboxProps }"
      :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
      <template #year="{ record }">
        <a @click="onDetail(record)">{{ record.year }}</a>
      </template>
      <template #auditStatus="{ record }">
        <a-popover>
              <template #content>
                  <p>{{record.secondAuditRemark || record.firstAuditRemark}}</p>
              </template>
              <a-tag v-if="record.isSubmit == 2 && record.auditStatus == 3" style="color: red;cursor: pointer;"
                     @click="onStatus(record)">未通过审核</a-tag>
          </a-popover>
          <a-tag v-if="record.isSubmit == 0 || (record.isSubmit == 2 && record.auditStatus == 0 && record.notarizeStatus == 0)"
                 style="color: red;cursor: pointer;">未提交</a-tag>
          <a-tag v-if="record.notarizeStatus == 2 && record.isSubmit == 2"
                 style="color: red;cursor: pointer;" @click="onStatus(record)">确认未通过</a-tag>
          <a-tag style="color: red;cursor: pointer;" v-if="record.isSubmit == 5 && record.auditStatus == 0" @click="onStatus(record)">已提交待确认</a-tag>
          <a-tag style="color: red;cursor: pointer;" v-if="record.isSubmit == 1 && record.auditStatus == 0" @click="onStatus(record)">已确认待初审</a-tag>
        <a-tag v-if="record.isSubmit == 1 && record.auditStatus == 1" style="color: red;cursor: pointer;"
          @click="onStatus(record)">已初审待复审</a-tag>
        <a-popover>
          <template #content>
            <p>如果状态显示审核通过，请点击申报资料下载，打印下载的申报资料一式三份，<br />盖章报回管委会319室，联系电话：0353-2292730</p>
          </template>
          <a-tag v-if="record.isSubmit == 1 && record.auditStatus == 2" style="color: green;cursor: pointer;"
            @click="onStatus(record)">通过审核</a-tag>
        </a-popover>
        <a-popover>
              <template #content>
                  <p>{{record.secondAuditRemark || record.firstAuditRemark}}</p>
              </template>
              <a-tag v-if="record.isSubmit == 1 && record.auditStatus == 3" style="color: red;cursor: pointer;"
                     @click="onStatus(record)">未通过审核
              </a-tag>
          </a-popover>
        <!-- <span>{{ text == 0 ? '待审核' : text == 1 ? '待复审' : text == 2 ? '审核通过' : text == 3 ? '审核不通过' : '' }}</span> -->
      </template>
      <template #action="{ record }">
        <div class="table-row-operations">
          <a v-if="record.isSubmit == 0 && record.auditStatus == 0" @click="onEdit(record)">编辑 </a>
          <a v-if="record.isSubmit == 2" @click="onEdit(record)">重新发起 </a>
          <a-popconfirm title="提交之后数据将不能修改，您确认要提交吗？" @confirm="onCommit(record)">
            <a v-if="(record.isSubmit == 0 || record.isSubmit == 2) && record.auditStatus == 0">提交 </a>
          </a-popconfirm>
          <!-- <a v-if="record.isSubmit == 1 && record.auditStatus == 0">已提交 </a> -->
          <span>
            <a v-if="record.auditStatus == 2" @click="getMoban(record)">申报资料下载</a>
            <span style="cursor: not-allowed;" v-else>申报资料下载</span>
          </span>
          <!-- <a-dropdown>
            <template #overlay>
              <a-menu>
                <a-menu-item key="1" v-if="record.isSubmit == 0 && record.auditStatus == 0">
                  <a @click="onEdit(record)">编辑</a>
                </a-menu-item>
                <a-menu-item key="2" v-if="record.auditStatus == 3 && record.isSubmit == 0">
                  <a @click="onEdit(record)">重新发起</a>
                </a-menu-item>
                <a-menu-item key="3" v-if="record.isSubmit == 0 && record.auditStatus == 0">
                  <a-popconfirm title="提交之后数据将不能修改，您确认要提交吗？" @confirm="onCommit(record)">
                    <a>提交</a>
                  </a-popconfirm>
                </a-menu-item>
                <a-menu-item key="4">
                  <span>
            <a v-if="record.auditStatus == 2" @click="getMoban(record)">申报资料下载</a>
            <span style="cursor: not-allowed;" v-else>申报资料下载</span>
          </span>
                </a-menu-item>
              </a-menu>
            </template>
            <a class="ant-dropdown-link" @click.prevent>更多
              <DownOutlined />
            </a>
          </a-dropdown> -->
        </div>
      </template>
    </a-table>
  </a-card>
  <UserModal ref="userModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
  <DetailModal ref="detailModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
  <StatusModal ref="statusModal" :form-primary-key-field="listKeyField" @finish="onFormEdited" />
</template>

<script>
import DetailModal from './components/DetailModal';
import UserModal from './components/newUserModal';
import StatusModal from './components/StatusModal';
import {tableListMixin} from "@/mixins";
import {sys_policy, sys_technologyBasedEnterprises} from "@/api/policyService";
import {dateFormat} from "@/config/variableConfig";
import {message} from "ant-design-vue";
import {companyInfo, EnterprisePolicyBasis, finance} from '@/api/companyService';
import axios from "axios";
import {ls} from "@/utils/util";
import {file_service} from "@/api/adminService";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "兑现年份", dataIndex: "year", key: "year", slots: { customRender: "year" } },
  { title: "经办人", dataIndex: "agent", key: "agent" },
  { title: "经办人联系电话", dataIndex: "agentPhone", key: "agentPhone" },
  { title: "依据政策拟申请金额（万元）", dataIndex: "amountApplied", key: "amountApplied" },
  { title: "状态", width: 120, dataIndex: "auditStatus", key: "auditStatus", slots: { customRender: "auditStatus" } },
  { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
  name: "index",
  mixins: [tableListMixin],
  components: {
    DetailModal, UserModal, StatusModal
  },
  data() {
    return {
      erweimaCode: '',
      dateFormat,
      columns,
      yearArr: [],
      queryParam: {},
      listUrl: sys_technologyBasedEnterprises.pageList,
      listKeyField: "id",
      deleteUrl: sys_technologyBasedEnterprises.remove,
      editUrl: sys_technologyBasedEnterprises.saveupdate,
        policyBasis:null
    }
  },
  mounted() {
    this.getYearData()
    this.erweimaCode = this.$ls.get('erweimaCode')
      this.getEnterprisePolicyBasis()
  },
  methods: {
      getEnterprisePolicyBasis(){
          this.getAction({
              url: EnterprisePolicyBasis.getByType,
              params: {
                  typeId: '11'
              }
          }).then((res)=>{
              this.policyBasis = res.policyBasis
          })
      },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    getYearData() {
      this.postAction({
        url: sys_policy.getYearData,
        params: { cashingTypeValue: '11', }
      }).then(res => {
        console.log('res111', res)
        let arr = []
        res.map(item => {
          arr.push({ label: item + '年', value: item + '' })
        })
        this.yearArr = arr
      })
    },
    onAdd() {
      if (this.yearArr.length > 0) {
        this.getAction({
          url: companyInfo.detail
        }).then(res => {
          if (res.companyName && res.oraganizationCode && res.detailedAddress && res.corporation) {
            this.getAction({
              url: finance.detail,
              params: {
                companyCode: this.$ls.get("companyCode")
              }
            }).then(aa => {
              if (aa.bankName && aa.bankAccount && aa.bankCode) {
                let obj = {
            isEdit: true,
                  year: this.yearArr.length == 1 ? this.yearArr[0].value : undefined,
                  yearArr: this.yearArr,
                  companyName: res.companyName,
                  oraganizationCode: res.oraganizationCode,
                  detailedAddress: res.detailedAddress,
                  openingBank: aa.bankName,
                  accountNumber: aa.bankAccount,
                  bankPermitFile: aa.bankPermitFile,
                  lineNumber: aa.bankCode,
                  subsidyKjrs: [],
                    policyBasis: this.policyBasis,
                    baseNId: res.baseNId,
                    baseName: res.baseName,
                }
                this.onShowModal('userModal', obj);
              } else {
                message.warning('请完善档案管理财务信息！')
            this.$router.push({ path: '/sys/finance' })
              }
            })
          } else {
            message.warning('请完善企业基本信息！')
            this.$router.push({ path: '/sys/companyInfo' })
          }
        })
      }else{
        message.warning('该政策兑现未开启！')
      }
    },
    onEdit(record) {
      this.getAction({
        url: companyInfo.detail
      }).then(corpInfo => {
        this.getAction({
          url: sys_technologyBasedEnterprises.detail,
          params: { id: record.id }
        }).then(res => {
          let arr = []
          if (res.subsidyKjrs.length > 0) {
            res.subsidyKjrs.map(item => {
              arr.push({
                ...item,
                key: item.id
              })
            })
          }
          let obj = {
            isEdit: false,
            ...corpInfo,
            ...res,
            year: res.year + '',
            yearArr: this.yearArr,
            subsidyKjrs: arr,
            auditStatus: 0,
            firstAuditStatus: 0,
            secondAuditStatus: 0,
          }
          this.onShowModal('userModal', obj);
        })
      })
    },
    onDetail(record) {
      this.getAction({
        url: companyInfo.detail
      }).then(corpInfo => {
        this.getAction({
          url: sys_technologyBasedEnterprises.detail,
          params: { id: record.id }
        }).then(res => {
          let obj = {
            ...corpInfo,
            ...res,
            agentIdCard: res.agentIdCard ? res.agentIdCard.substr(0, 5) + '***********' + res.agentIdCard.substr(15, res.agentIdCard.split('').length) : ''
          }
          this.onShowModal('detailModal', obj);
        })
      })
    },
    onStatus(record) {
      this.getAction({
        url: sys_technologyBasedEnterprises.detail,
        params: { id: record.id }
      }).then(res => {
        let obj = {
          ...res,
        }
        this.onShowModal('statusModal', obj);
      })
    },
    onGetCheckboxProps(record) {
      return {
        disabled: record.isSubmit != 0, // Column configuration not to be checked
      }
    },
    onCommit(record) {
      this.postAction({
        url: sys_technologyBasedEnterprises.commitUrl,
        params: {
          id: record.id,
          isSubmit: 5,
          auditStatus: 0,
          firstAuditStatus: 0,
          secondAuditStatus: 0,
          year: record.year,
          firstAuditRemark: '',
          secondAuditRemark: '',
        },
        returnMsg: true
      }).then(() => {
        this.$message.success('操作成功！');
        this.onFormEdited()
      })
    },
    getMoban(record) {
      axios({
        methods: "get",
        url: sys_policy.ziliaoDownload,
        params: {
          subsidyId: record.id,
          cashingType: '11'
        },
        responseType: 'arraybuffer',
        headers: {
          // 'content-type': 'application/x-www-form-urlencoded',
          Authorization: 'Bearer' + ls.get('token') || ''
        }
      }).then(data => {
        const blob = new Blob([data.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url)
        // const link = document.createElement("a"); // 创建a标签
        // link.href = url;
        // link.download = decodeURIComponent('科技型企业补贴申请资料.pdf');// 文件重命名，若无需重命名，将该行删去
        // link.click();
        // URL.revokeObjectURL(url); // 释放内存
      })
    },
  }
}
</script>

<style scoped>
.twoCode {
  position: absolute;
  right: 5px;
  top: 5px;
  width: 100px;
  height: 100px;
}
.codeBox{
  width: 80px;
  height: 80px;cursor: pointer;
}
</style>
